import { NewRelic } from "@2u-landing-pages/components/NewRelic";
import React from "react";
import { LogPageNotFound } from "./LogNotFound";

export const PageNotFound: React.FC = () => {
  return (
    <>
      <head>
        <NewRelic />
      </head>
      <body>
        <div
          style={{
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            flexDirection: "column",
          }}
        >
          <h2>Not Found</h2>
          <p>Could not find requested resource</p>
          <LogPageNotFound />
        </div>
      </body>
    </>
  );
};
